'use strict'

/**
 *
 * @name: nnBaseSwiper
 *
 */

import DirectiveTemplate from './nn-base-swiper.directive.html'
import './nn-base-swiper.directive.scss'

function NnBaseSwiperDirective ($timeout, $rootScope) {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      options: '=*',
      arrowsTop: '=*'
    },
    template: DirectiveTemplate,
    link: {
      post: (scope, element) => {

        /*
         *
         * @CONFIG
         *
         */

        scope.showArrows = false
        let _swiper
        const _optionsDefault = {
          slidesPerView: 'auto',
          loop: false,
          direction: 'horizontal',
          spaceBetween: 25,
          navigation: {
            nextEl: '.js-next',
            prevEl: '.js-prev'
          },
          slideClass: 'js-swiper-slide',
          centeredSlides: $rootScope.$bp === 'ltMobileXS',
          speed: $rootScope.$bp === 'ltMobileXS' ? 150 : 200
        }

        /*
         *
         * @PRIVATE
         *
         */

        const _exposeInstance = () => {
          _swiper.setUpdate = () => $timeout(() => _swiper.update())
          scope.$parent.baseSwiper = _swiper
        }

        const _initSwiper = () => {
          const _options = Object.assign(_optionsDefault, scope.options)

          if (!_swiper) {
            _swiper = new Swiper(element, _options)
          } else {
            $timeout(() => _swiper.update())
          }
        }

        const _centerArrowsPos = () => {
          let img

          const interval = setInterval(() => {
            img = element[0].querySelector('img')
            console.log('nn-base-swiper interval')
            if (img) {
              clearInterval(interval)
              $timeout(() => {
                center(img.parentNode)
              }, 300)
            }
          }, 500)

          function center (relativeEl) {
            const containerCoords = element[0].getBoundingClientRect()
            const relativeElCoords = relativeEl.getBoundingClientRect()
            const distance = relativeElCoords.top - containerCoords.top

            scope.arrowsTop = distance + relativeElCoords.height/2 + 'px'

            scope.showArrows = true
          }
        }


        /*
         *
         * @INIT
         *
         */

        $timeout(_initSwiper).then(() => {
          _exposeInstance()
          if (!scope.arrowsTop) {
            _centerArrowsPos()
          } else {
            scope.showArrows = true
          }
        })
      }
    }
  }
}

export default NnBaseSwiperDirective



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-swiper/nn-base-swiper.directive.js